export const Guid = {
    OPENFLEX: "975f225a-592f-4062-b34e-cf2097e17286",
    GLOBALDEALER: "37ceda71-a484-4b4a-bf6b-ae74080d9257"
}

export default Guid